import { isEmpty } from 'lodash';

import { invertObject } from './common';
import { STATUSES } from '../constants';

export default function getUserStepsStatistics(transitionsDat, transitionsJson) {
  const userTransitions = {};

  if (isEmpty(transitionsDat) || isEmpty(transitionsJson.users)) {
    return userTransitions;
  }

  const statesInverted = invertObject(transitionsJson.states);
  const statesToCount = [
    statesInverted[STATUSES.COMPLETED],
    statesInverted[STATUSES.REVIEWED],
    statesInverted[STATUSES.LOCKED]
  ].filter(state => state !== undefined).map(strNum => Number(strNum));

  // add transitions to userTransitions object
  transitionsDat.forEach(row => {
    const [projectPath, user, date, state] = row;
    if (!userTransitions[user]) {
      userTransitions[user] = {};
    };
    if (statesToCount.includes(state)) {
      if (!userTransitions[user][projectPath]) {
        userTransitions[user][projectPath] = {};
        statesToCount.forEach(stat => {userTransitions[user][projectPath][stat] = []})
      };
      userTransitions[user][projectPath][state].push(date);
    }
  });

  return userTransitions;
}